import { Text } from "@ecco/ui/text";
import { Flex } from "@ecco/ui/flex";
import { Button } from "@ecco/ui/button";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { CommonCMS } from "@lib/constants/contentful";
import { ECCOIcon } from "@ecco/ui/ecco-icon";
import { space } from "@ecco/ui/tokens";
import { ModalTypes } from "@lib/enums/ModalTypes";
import type { Session } from "next-auth";
import { bottomContainerMobileStyles } from "@components/layouts/navigation/styles";
import LogoutButton from "@components/auth/LogOutButton";
import { RUM_ACTION_NAME } from "@lib/monitoring/rumActionNames";

interface MobileNavigationContainerProps {
    isAuthenticated: boolean;
    session: Session;
    showModal: (modalType: ModalTypes) => void;
    onCloseMenu: () => void;
}

const StyledMicroCopy = ({ prefix, namePart }: { prefix?: string; namePart?: string }) => {
    if (!prefix || !namePart) return null;

    return (
        <Flex gap={1}>
            <Text
                fontSize="desktopBodyTextTiny"
                color="gray.200"
                whiteSpace="normal"
                fontWeight="semibold"
            >
                {prefix}
            </Text>
            <Text
                fontSize="desktopBodyTextTiny"
                color="black"
                whiteSpace="normal"
                fontWeight="semibold"
            >
                {namePart}
            </Text>
        </Flex>
    );
};

export const MobileBottomContainer = ({
    isAuthenticated,
    session,
    showModal,
    onCloseMenu,
}: MobileNavigationContainerProps) => {
    const { get: getMicrocopy } = useMicrocopy();
    const loggedInAsLabel = getMicrocopy(CommonCMS.shared, CommonCMS.loggedInAs, {
        replacements: { name: session?.user?.name },
    });
    const [prefix, namePart] =
        typeof loggedInAsLabel === "string" ? loggedInAsLabel.split(":") : [];

    return (
        <Flex sx={bottomContainerMobileStyles}>
            {isAuthenticated ? (
                <>
                    <StyledMicroCopy prefix={prefix} namePart={namePart} />
                    <LogoutButton variant="standard" fontSize={"desktopBodyTextTiny"} />
                </>
            ) : (
                <>
                    <Text
                        fontSize={"desktopBodyTextTiny"}
                        color="black"
                        whiteSpace={"normal"}
                        fontWeight="bold"
                    >
                        {getMicrocopy(CommonCMS.shared, CommonCMS.ECCOMember)}
                    </Text>
                    <Flex flexDir={"row"} gap={space["0.2"]}>
                        <Button
                            rightIcon={<ECCOIcon name="arrow-right" />}
                            variant={"standard"}
                            onClick={() => {
                                onCloseMenu();
                                showModal(ModalTypes.createAccount);
                            }}
                            data-dd-action-name={RUM_ACTION_NAME.CREATE_ACCOUNT}
                        >
                            <span>
                                {getMicrocopy(CommonCMS.shared, CommonCMS.button.createAccount)}
                            </span>
                        </Button>
                        <Button
                            rightIcon={<ECCOIcon name="arrow-right" />}
                            variant={"standard"}
                            onClick={() => {
                                onCloseMenu();
                                showModal(ModalTypes.login);
                            }}
                            data-dd-action-name={RUM_ACTION_NAME.LOG_IN}
                        >
                            <span>{getMicrocopy(CommonCMS.shared, CommonCMS.button.logIn)}</span>
                        </Button>
                    </Flex>
                </>
            )}
        </Flex>
    );
};
